import Axios from '@/utils/Axios';

import { Products, ProductsFilter, Reviews } from '@/types/e-commerce';

const products: Products[] = [
  {
    id: 5,
    image: 'prod-5.png',
    name: 'Canon EOS 1500D 24.1 Digital SLR',
    brand: 'Canon',
    offer: '30%',
    description: 'SLR Camera (Black) with EF S18-55...',
    about:
      'Image Enlargement: After shooting, you can enlarge photographs of the objects for clear zoomed view. Change In Aspect Ratio: Boldly crop the subject and save it with a composition that has impact. You can convert it to a 1:1 square format, and after shooting you can create a photo that will be popular on SNS.',
    quantity: 50,
    rating: 3.5,
    discount: 15,
    salePrice: 15.99,
    offerPrice: 12.99,
    gender: 'male',
    categories: ['electronics', 'camera'],
    colors: ['warningMain', 'primary200'],
    popularity: 2446747676704768,
    date: 5332560794091520,
    created: new Date('2024-12-13T18:50:56.545Z'),
    isStock: true,
    new: 25
  },
  {
    id: 7,
    image: 'prod-7.png',
    name: 'Apple MacBook Pro with Iphone',
    brand: 'Apple',
    offer: '20%',
    description: '11th Generation Intel® Core™ i5-11320H...',
    about:
      "Great choice for those who love powerful and fast laptops. It comes with 2TB of hard drive and 12GB of RAM. It's fast and comes with a powerful processor.",
    quantity: 70,
    rating: 4,
    discount: 16,
    salePrice: 14.59,
    offerPrice: 14.59,
    gender: 'male',
    categories: ['electronics', 'laptop'],
    colors: ['errorDark', 'secondaryMain', 'errorMain'],
    popularity: 5797179968978944,
    date: 1915408688873472,
    created: new Date('2024-12-30T06:30:56.545Z'),
    isStock: true,
    new: 30
  },
  {
    id: 4,
    image: 'prod-4.png',
    name: 'Luxury Watches Centrix Gold',
    brand: 'Centrix',
    offer: '20%',
    description: '7655 Couple (Refurbished)...',
    about:
      'This product from Centrix is a classic choice for those who love classical products. It is made of pure gold and weighs around 50 grams.',
    quantity: 3,
    rating: 4,
    discount: 20,
    salePrice: 36,
    offerPrice: 29.99,
    gender: 'kids',
    categories: ['fashion', 'watch'],
    colors: ['errorLight', 'warningMain'],
    popularity: 3064970585571328,
    date: 768885125021696,
    created: new Date('2024-12-08T21:50:56.545Z'),
    isStock: true,
    new: 15
  },
  {
    id: 3,
    image: 'prod-3.png',
    name: 'Fitbit MX30 Smart Watch',
    brand: 'Fitbit',
    offer: '30%',
    description: '(MX30- waterproof) watch',
    about:
      'Fitbit is well known for making amazing smartwatches, and this product is one of them. It is waterproof and the battery can last up to 2 days. Great product for smartwatch lovers.',
    quantity: 70,
    rating: 4.5,
    discount: 40,
    salePrice: 85,
    offerPrice: 49.9,
    gender: 'male',
    categories: ['fashion', 'watch'],
    colors: ['primary200', 'primaryDark'],
    popularity: 8158051093708800,
    date: 4969258354212864,
    created: new Date('2024-12-11T18:45:56.545Z'),
    isStock: true,
    new: 35
  },
  {
    id: 2,
    image: 'prod-2.png',
    name: 'Boat On-Ear Wireless',
    brand: 'Boat',
    offer: '10%',
    description: 'Mic(Bluetooth 4.2, Rockerz 450R...)',
    about:
      'Boat On-ear wireless headphones come with Bluetooth technology, better sound quality, and weigh around 200g, which seems very light when using.',
    quantity: 45,
    rating: 3.5,
    discount: 10,
    salePrice: 81.99,
    offerPrice: 81.99,
    gender: 'kids',
    categories: ['electronics', 'headphones'],
    colors: ['primary200', 'successLight', 'secondary200', 'warningMain'],
    popularity: 4338363500855296,
    date: 6250822342017024,
    created: new Date('2024-12-05T19:26:56.545Z'),
    isStock: false,
    new: 40
  },
  {
    id: 6,
    image: 'prod-6.png',
    name: 'Apple iPhone 13 Mini',
    brand: 'Apple',
    offer: '70%',
    description: '13 cm (5.4-inch) Super...',
    about:
      'It fits for those who love photography since it has a 48MP camera that shoots great photos even in low light. It also has 8GB of RAM and a 4000mAh battery that can last up to 12 hours a day.',
    quantity: 40,
    rating: 4.5,
    discount: 10,
    salePrice: 86.99,
    offerPrice: 86.99,
    gender: 'female',
    categories: ['electronics', 'iphone'],
    colors: ['primaryDark'],
    popularity: 3035671516151808,
    date: 83175820754944,
    created: new Date('2024-12-22T14:35:56.545Z'),
    isStock: true,
    new: 15
  },
  {
    id: 8,
    image: 'prod-8.png',
    name: 'Apple iPhone 13 Pro',
    brand: 'Apple',
    offer: '70%',
    description: '(512GB ROM, MLLH3HN/A,...)',
    about:
      "This smartphone comes with 12GB of RAM and a 2GHz processor. There are two front cameras, one of 20MP and the second of 10MP for depth photography. It's lightweight and fast.",
    quantity: 21,
    rating: 4.5,
    discount: 30,
    salePrice: 129.99,
    offerPrice: 100,
    gender: 'female',
    categories: ['electronics', 'iphone'],
    colors: ['errorMain', 'successDark'],
    popularity: 6876409521766400,
    date: 1129830584156160,
    created: new Date('2024-12-15T17:25:56.545Z'),
    isStock: true,
    new: 20
  },
  {
    id: 1,
    image: 'prod-1.png',
    name: 'Apple Series 4 GPS A38 MM Space',
    brand: 'Apple',
    offer: '75%',
    description: 'Apple Watch SE Smartwatch',
    about:
      'This watch from Apple is highly known for its features, like you can control your Apple smartphone with this watch and do everything you would want to do on your smartphone.',
    quantity: 3,
    rating: 4,
    discount: 75,
    salePrice: 275,
    offerPrice: 275,
    gender: 'male',
    categories: ['fashion', 'watch'],
    colors: ['errorDark', 'errorMain', 'secondaryMain'],
    popularity: 8934863277129728,
    date: 4262307347562496,
    created: new Date('2024-12-07T22:15:56.545Z'),
    isStock: true,
    new: 45
  }
];
// ⬇️ this is the loader for the detail route
export async function loader() {
  try {
    // const response = await Axios.get('/api/products/list');
    // return response.data.products as Products[];
    // console.log(products);
    return products;
  } catch (error) {
    return error;
  }
}

export async function filterProducts(filter: ProductsFilter) {
  // return await Axios.post('/api/products/filter', { filter });
  // console.log(products);
  return products;
}

export async function productLoader({ params }: any) {
  try {
    // const response = await Axios.post('/api/product/details', { id: params.id });
    // return response.data as Products;
    const productId = parseInt(params.id);
    const selectedProduct = products.find((product) => product.id === productId);

    return selectedProduct;
  } catch (error) {
    return error;
  }
}

export async function getRelatedProducts(id: string | undefined) {
  // return await Axios.post('/api/product/related', { id });
  return products;
}

export async function getProductReviews() {
  // return await Axios.get('/api/review/list');
  const reviews: Reviews[] = [
    {
      id: '1',
      rating: 4.1885,
      review:
        'Ru zar zi dajwe akewupo guhpogto ki nur sogibe uvker wor sihok gefeh zi ru faz zacape cuwne. Cuwcet eragmoj gahi ar jiretag lumcig ah ujidet ig ban cu jim uhmar vidivim ti enu hudivo.',
      date: '2024-12-16T05:38:15.157Z',
      profile: {
        avatar: 'avatar-1.png',
        name: 'Cornelia Andrews',
        status: false
      }
    },
    {
      id: '2',
      rating: 3.6921,
      review:
        'Cih pe sumsubiz leaw suz bec jototji gegbacihi ka mek zedlo ami baeto. Muvzovcoh fevut mej zi bavwuh lu ci bazotuva nat vi zuco bi.',
      date: '2024-12-10T18:28:15.157Z',
      profile: {
        avatar: 'avatar-2.png',
        name: 'Alta Perez',
        status: false
      }
    },
    {
      id: '3',
      rating: 4.7535,
      review:
        'Mokhagocu jimap girjoh ke ortaz humoko pe ugu mu fip lamapetiw fap ekno ca dabgu ce citzu mol. Imiilekec sabafud em keracibe ridpuc sa dedjam uja mi di liodeh fiz ziom nazozso.',
      date: '2024-12-08T01:03:15.158Z',
      profile: {
        avatar: 'avatar-3.png',
        name: 'Harriett Blair',
        status: false
      }
    }
  ];
  return reviews;
}
